export const QUEUE_OPERATION = "QUEUE_OPERATION";
export type QUEUE_OPERATION = typeof QUEUE_OPERATION;

export const APPLY_OPERATION = "APPLY_OPERATION";
export type APPLY_OPERATION = typeof APPLY_OPERATION;
